import castArray from 'lodash/castArray'
import compact from 'lodash/compact'
import slice from 'lodash/slice'
import React, { FC, memo, ReactElement, useMemo, useState } from 'react'

import { ExpandableListItem, ExpandableListItemProps } from '@Components/ExpandableList/Item'

import {
  ExpandableListElement, ExpandableListIconWrapper,
  ExpandableListToggleButton,
  ExpandableListToggleIcon,
  ExpandableListWrapper,
} from './styled'

interface ExpandableListProps {
  children: ReactElement<ExpandableListItemProps, typeof ExpandableListItem>[]
}

const ITEM_LIMIT = 3

export const ExpandableList: FC<ExpandableListProps> = memo(({ children }) => {
  const items = useMemo(() => compact(castArray(children)), [children])
  const shouldExpand = items.length > ITEM_LIMIT
  const [expanded, setExpanded] = useState(!shouldExpand)

  if (items.length === 0) {
    return null
  }

  return (
    <ExpandableListWrapper>
      <ExpandableListElement isExpanded={expanded}>
        {expanded ? items : slice(items, 0, ITEM_LIMIT)}
      </ExpandableListElement>
      {shouldExpand && (
        <ExpandableListToggleButton isExpanded={expanded} onClick={() => setExpanded(isExpanded => !isExpanded)} type="button">
          <ExpandableListIconWrapper isExpanded={expanded}>
            <ExpandableListToggleIcon />
          </ExpandableListIconWrapper>
        </ExpandableListToggleButton>
      )}
    </ExpandableListWrapper>
  )
})
